// @flow
import React, { useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Checkbox, Popup } from 'semantic-ui-react';
import EditIcon from '../../../../assets/add-ons/edit.svg';
import ChevronUp from '../../../../assets/add-ons/chevron_up.svg';
import ChevronDown from '../../../../assets/add-ons/chevron_down.svg';
 import styles from '../mobile-styles-module.css';
import { locale } from '../locale';
import { ACTIVE } from '../../consts';

const AddOnRow = injectIntl(({
  intl,
  addOn,
  rate,
  index,
  formatPrices,
  formatAvailable,
  hasPermissionForManageAddOns,
  history,
  isDisabled,
  isAllSoldOut,
  onAddOnsDelete,
  onAddOnsStatusChange,
}) => {
  const [isDetailShowing, setIsDetailShowing] = useState(false);
  const firstRate = rate?.[0];

  const deleteButton = (
    <button
      className="ui fluid icon button"
      onClick={() => onAddOnsDelete(index)}
      disabled={isDisabled}
    >
      <i aria-hidden="true" className="grey large icon universe-delete"/>
    </button>
  );

  const renderActions = () => {
    return (
      <div className={styles.actions}>
        <div className={styles.editIcon}>
          <button
            className="ui fluid icon button"
            onClick={() => history.push(`/dashboard/add-ons/edit/${addOn.id}`)}
          >
            <EditIcon />
          </button>
        </div>
        <div className={styles.trashDeleteIcon}>
          {isDisabled
            ? <Popup
                content={intl.formatMessage(locale.cannotDeleteSoldAddOn)}
                trigger={<span role="button" aria-disabled="true" tabIndex={0}>{deleteButton}</span>}
                on={['hover', 'focus']}
                position="top right"
                inverted
                basic
              />
            : deleteButton}
        </div>
      </div>
    );
  }

  const renderImage = () => {
    const imageUrl = firstRate?.imageUrl;
    return imageUrl &&
      <div className={styles.imageContainer}>
        {/* Decorative: the add-on name is rendered adjacent, so alt text here would only duplicate it. */}
        <img
          src={imageUrl}
          className={styles.addOnImage}
          alt=""
        />
      </div>;
  }

  const renderAddOnOptions = () => {
    if (addOn?.rates?.length > 1) {
      return addOn?.rates?.map(r => <div className={styles.option} key={r.id}>{r.optionName}</div>);
    }
    return intl.formatMessage(locale.noOptions);
  }

  const renderAddOnDetails = () => {
    const selectedTicketTypesIndicator = <div>
      {addOn?.addOnCustomizations?.length
      ? intl.formatMessage(locale.specificTicketTypesSelectedIndicators)
      : intl.formatMessage(locale.allTicketTypesSelectedIndicators)}
    </div>;

    const selectedTimeslotIndicator = <div>
      { addOn?.addOnAvailabilityRules.length > 0
        ? intl.formatMessage(locale.specificTimeslot)
        : intl.formatMessage(locale.allTimeslot)
      }
    </div>

      const listingsCountText = () => {
        const addOnsEventLength = addOn?.events?.length;
        if (addOnsEventLength === 0) {
          return 'All';
        }
        return `${addOnsEventLength}`;
      };

    if (isDetailShowing) {
      const selectedEventMessage = addOn?.events?.length > 1
        ? locale.allOrSomeEventsAndTickets
        : locale.oneEventSelected;

      return <div className={styles.mobileAddOnDetails}>
        <div className={styles.mobileAddOnDetailsRow}>
          <div>
            <div className={styles.label}>{intl.formatMessage(locale.options)}</div>
            <div className={styles.addOnOption}>{renderAddOnOptions()}</div>
          </div>
          <div>
            <div className={styles.label}>{intl.formatMessage(locale.price)}</div>
            <div className={styles.addOnPrice}>{formatPrices()}</div>
          </div>
        </div>
        <div className={styles.rowDivider} />
        <div className={styles.mobileAddOnDetailsRow}>
          <div>
            <div className={styles.label}>{intl.formatMessage(locale.available)}</div>
            <div className={styles.addOnQuantity}>{formatAvailable()}</div>
          </div>
          <div className={styles.appliedToRow}>
            <div className={styles.label}>{intl.formatMessage(locale.appliesTo)}</div>
            <div className={styles.addOnAppliesTo}>
              {
                <FormattedMessage
                  {...selectedEventMessage}
                  values={{ currencyCode: addOn.currency, listingsCountText: listingsCountText() }}
                />
              }
              {selectedTicketTypesIndicator}
              {selectedTimeslotIndicator}
            </div>
          </div>
          <div className={styles.addOnAction}>
            {hasPermissionForManageAddOns && renderActions()}
          </div>
        </div>
      </div>
    }

    return <></>;
  }

  const handleDetailToggle = () => {
    setIsDetailShowing(!isDetailShowing);
  }

  const addOnNameClasses = `${styles.addOnName} ${!firstRate?.imageUrl ? styles.nameWithImage : ''}`
  const addOnDetailsClasses =
    `${styles.addOnRowDetails} ${!firstRate?.imageUrl ? styles.addOnRowDetailsWithoutImage : ''}`

  return (
    <div className={styles.mobileAddOnRow}>
      <div className={styles.mobileRowHeader} onClick={handleDetailToggle} role="button" tabIndex={0}>
        <div className={addOnDetailsClasses}>
          <Checkbox
            disabled={isAllSoldOut}
            toggle
            checked={firstRate?.state === ACTIVE}
            onChange={(_, { checked }) => onAddOnsStatusChange(index, checked)}
          />
          {renderImage()}
          <div className={addOnNameClasses}>{addOn.name}</div>
          </div>
        <div className={styles.addDetailToggle}>
          <button className="ui fluid icon button">
            {isDetailShowing ? <ChevronUp /> : <ChevronDown />}
          </button> 
        </div>
      </div>
      {renderAddOnDetails()}
    </div>
  )
});

export default AddOnRow;
